export const PERMACHINE = {
  PERMACHINESALESLISTS: 'per_machine_sales_lists',
  PERMACHINESUMMARYSALESLISTS: 'per_machine_summary_sales_lists',
  MACHINELISTS: 'machine_lists',
  MACHINECOINHISTORY: 'machine_coin_history',
  PERMACHINESTOCK: 'per_machine_stock',
  WEBSOCKET_TERMINALS: 'websocket_terminals',
};
